<template>
    <div class="language-switch" aria-label="Language">
        <button
            type="button"
            class="lang-option"
            :class="{ active: !isEnglish }"
            :aria-pressed="!isEnglish"
            @click="setLanguage('th')"
        >
            ไทย
        </button>
        <button
            type="button"
            class="lang-option"
            :class="{ active: isEnglish }"
            :aria-pressed="isEnglish"
            @click="setLanguage('en')"
        >
            EN
        </button>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { localeOptions } from '../../constants/config';

export default {
    name: 'languagePage',
    data() {
        return {
            isActive: false,
            localOptions: localeOptions,
        };
    },
    computed: {
        ...mapGetters({
            langIcon: 'langIcon',
            langLangauge: 'langLangauge'
        }),
        isEnglish() {
            const current = (this.langLangauge || localStorage.getItem('currentLanguage') || 'th').toLowerCase();
            return current === 'en';
        }
    },
    methods: {
        getLocaleOption(languageId) {
            return localeOptions.find((option) => option.id === languageId) || localeOptions[0];
        },
        setLanguage(languageId) {
            const nextOption = this.getLocaleOption(languageId);
            this.changeLocale(nextOption, nextOption.id);
        },
        changeLocale(value, language) {
            this.$i18n.locale = language;
            this.$store.dispatch('setLang', value);
            location.reload();
        },
    },
    mounted() {
        const savedLanguage = localStorage.getItem('currentLanguage') || 'th';
        const savedOption = this.getLocaleOption(savedLanguage);
        this.$store.dispatch('setLang', savedOption);
    }
}
</script>

<style scoped>
.language-switch {
    display: inline-flex;
    align-items: center;
    padding: 1.9px;
    border-radius: 9999px;
    border: 1px solid #e5e7eb;
    background: #ffffff;
    font-size: 11.4px;
    font-weight: 600;
    line-height: 1;
}

.lang-option {
    border: none;
    background: transparent;
    color: #525762;
    border-radius: 9999px;
    padding: 5.7px 9.5px;
    font-size: 11.4px;
    font-weight: 600;
    line-height: 1;
    cursor: pointer;
    transition: all 0.2s ease;
}

.lang-option.active {
    background: #66b5ff;
    color: #ffffff;
    box-shadow: 0 1px 2px rgba(37, 99, 235, 0.2);
}
</style>
